var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { attrs: { "label-width": "0", inline: "" } },
    [
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.DMN_SEAPORT,
              label: _vm.$t("Menu.Harbour"),
              disabled: ""
            }
          }),
          !_vm.obj.DMN_SEAPORT
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("DMN_SEAPORT")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.DMN_AIRPORT,
              label: _vm.$t("Menu.Airport"),
              disabled: ""
            }
          }),
          !_vm.obj.DMN_AIRPORT
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("DMN_AIRPORT")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c("br"),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.DMN_CHARGE_ITEM,
              label: _vm.$t("Menu.ChargesItems"),
              disabled: ""
            }
          }),
          !_vm.obj.DMN_CHARGE_ITEM
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("DMN_CHARGE_ITEM")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.DMN_REGION,
              label: _vm.$t("Menu.AirRoute"),
              disabled: ""
            }
          }),
          !_vm.obj.DMN_REGION
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("DMN_REGION")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c("br"),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.DMN_NETWORK,
              label: _vm.$t("Menu.NetWork"),
              disabled: ""
            }
          }),
          !_vm.obj.DMN_NETWORK
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("DMN_NETWORK")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.DMN_CURRENCY,
              label: _vm.$t("Menu.Currency"),
              disabled: ""
            }
          }),
          !_vm.obj.DMN_CURRENCY
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("DMN_CURRENCY")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c("br"),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.DMN_EQ_TYPE,
              label: _vm.$t("Menu.EQType"),
              disabled: ""
            }
          }),
          !_vm.obj.DMN_EQ_TYPE
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("DMN_EQ_TYPE")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.DMN_PACKING,
              label: _vm.$t("Menu.Packing"),
              disabled: ""
            }
          }),
          !_vm.obj.DMN_PACKING
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("DMN_PACKING")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c("br"),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.DMN_HOUSE_BL_TYPE,
              label: _vm.$t("Menu.HouseBlType"),
              disabled: ""
            }
          }),
          !_vm.obj.DMN_HOUSE_BL_TYPE
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("DMN_HOUSE_BL_TYPE")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.DMN_CARGO_TYPE,
              label: _vm.$t("Menu.CargoType"),
              disabled: ""
            }
          }),
          !_vm.obj.DMN_CARGO_TYPE
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("DMN_CARGO_TYPE")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c("br"),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.DMN_INCO_TERM,
              label: _vm.$t("Menu.IncoTerm"),
              disabled: ""
            }
          }),
          !_vm.obj.DMN_INCO_TERM
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("DMN_INCO_TERM")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.DMN_SHIPPING_TERM,
              label: _vm.$t("Menu.ShippingTerm"),
              disabled: ""
            }
          }),
          !_vm.obj.DMN_SHIPPING_TERM
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("DMN_SHIPPING_TERM")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c("br"),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.SYS_TRADE_TERM,
              label: _vm.$t("Menu.TradeTerm"),
              disabled: ""
            }
          }),
          !_vm.obj.SYS_TRADE_TERM
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("SYS_TRADE_TERM")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.SYS_CUSTOMER_TYPE,
              label: _vm.$t("Menu.CustomerType"),
              disabled: ""
            }
          }),
          !_vm.obj.SYS_CUSTOMER_TYPE
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("SYS_CUSTOMER_TYPE")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c("br"),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.PRC_PORT_GROUP,
              label: _vm.$t("Menu.PortGroup"),
              disabled: ""
            }
          }),
          !_vm.obj.PRC_PORT_GROUP
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("PRC_PORT_GROUP")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.SYS_OTHER_CHARGE_ITEM,
              label: _vm.$t("Menu.OtherChargeItem"),
              disabled: ""
            }
          }),
          !_vm.obj.SYS_OTHER_CHARGE_ITEM
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("SYS_OTHER_CHARGE_ITEM")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c("br"),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.SYS_OTHER_CHARGE_ITEM,
              label: _vm.$t("Menu.BusinessStatus"),
              disabled: ""
            }
          }),
          !_vm.obj.SYS_OTHER_CHARGE_ITEM
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("SYS_OTHER_CHARGE_ITEM")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.SYS_OTHER_CHARGE_ITEM,
              label: _vm.$t("Menu.PermissionConfig"),
              disabled: ""
            }
          }),
          !_vm.obj.SYS_OTHER_CHARGE_ITEM
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("SYS_OTHER_CHARGE_ITEM")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c("br"),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.SYS_OTHER_CHARGE_ITEM,
              label: _vm.$t("Menu.Report"),
              disabled: ""
            }
          }),
          !_vm.obj.SYS_OTHER_CHARGE_ITEM
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("SYS_OTHER_CHARGE_ITEM")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.SYS_CUSTOMER_TYPE,
              label: _vm.$t("Menu.ConfigurationManagement"),
              disabled: ""
            }
          }),
          !_vm.obj.SYS_CUSTOMER_TYPE
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("SYS_CUSTOMER_TYPE")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c("br"),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.CODE_MODULE,
              label: _vm.$t("Menu.ShippingCompaniesAirlines"),
              disabled: ""
            }
          }),
          !_vm.obj.CODE_MODULE
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("CODE_MODULE")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.COUNTRY,
              label: _vm.$t("Menu.Template"),
              disabled: ""
            }
          }),
          !_vm.obj.COUNTRY
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("SYS_TEMPLATE", "COUNTRY")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c("br"),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.SYS_SEQUENCE,
              label: _vm.$t("Menu.Sequence"),
              disabled: ""
            }
          }),
          !_vm.obj.SYS_SEQUENCE
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("SYS_SEQUENCE")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.DMN_BL_MODE,
              label: _vm.$t("Menu.BlMode"),
              disabled: ""
            }
          }),
          !_vm.obj.DMN_BL_MODE
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("SYS_TEMPLATE", "DMN_BL_MODE")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c("br"),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.DMN_CUSTOM_JOB_TYPE,
              label: _vm.$t("Menu.CustomJobType"),
              disabled: ""
            }
          }),
          !_vm.obj.DMN_CUSTOM_JOB_TYPE
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("DMN_CUSTOM_JOB_TYPE")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.DMN_TRANSMIT_FILE_TYPE,
              label: _vm.$t("Menu.TransmitFileType"),
              disabled: ""
            }
          }),
          !_vm.obj.DMN_TRANSMIT_FILE_TYPE
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("DMN_TRANSMIT_FILE_TYPE")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c("br"),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.PRC_AIR_SERVICE,
              label: _vm.$t("Menu.AirService"),
              disabled: ""
            }
          }),
          !_vm.obj.PRC_AIR_SERVICE
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("PRC_AIR_SERVICE")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.DOCUMENTCATEGORY,
              label: _vm.$t("Menu.documentCategory"),
              disabled: ""
            }
          }),
          !_vm.obj.DOCUMENTCATEGORY
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("DOCUMENTCATEGORY")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c("br"),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.SINGLEONLINESET,
              label: _vm.$t("Menu.SingleOnlineSet"),
              disabled: ""
            }
          }),
          !_vm.obj.SINGLEONLINESET
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("SINGLEONLINESET")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticStyle: { width: "280px" } },
        [
          _c("el-checkbox", {
            staticStyle: { width: "200px" },
            attrs: {
              value: _vm.obj.DMN_CHARGE_UNIT,
              label: _vm.$t("Menu.charegeUnit"),
              disabled: ""
            }
          }),
          !_vm.obj.DMN_CHARGE_UNIT
            ? _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.initClickHandler("DMN_CHARGE_UNIT")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.Initialize")))]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }